/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, Flex, message, Typography } from "antd";
import {
  Row,
  Col,
  Space,
  InputNumber,
  Divider,
  Badge,
  Select,
  Modal,
  Upload,
} from "antd";

import { SaveFilled, SearchOutlined } from "@ant-design/icons";

import { ButtonBack, uploadButton } from "../../../components/button";
import ModalPackingType from "../../../components/modal/ERP/packing/ModalPackingType";
import ModalSupplier from "../../../components/modal/supplier/ModalSupplier";
import ModalUnit from "../../../components/modal/ERP/unit/ModalUnit.jsx";

import PackingService from "../../../service/ERP/Packing.service";
import OptionService from "../../../service/ERP/Options.service";
import { useLocation, useNavigate } from "react-router";
import { delay, BACKEND_URL_MAIN } from "../../../utils/util";
import Swal from "sweetalert2";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const pkservice = PackingService();
const opService = OptionService();
const { Text } = Typography;

const from = "/ERP/packing-master";

const PackingManage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const [form] = Form.useForm();

  /* CBM คำนวณสดจาก กว้าง x ยาว x สูง — ไม่ให้แก้ไข ใช้ตรวจทานเฉยๆ */
  const wide = Form.useWatch("wide", form);
  const long = Form.useWatch("long", form);
  const high = Form.useWatch("high", form);
  const hasSize = [wide, long, high].every((v) => v !== undefined && v !== null && v !== "");
  /* ขนาดกรอกเป็น ซม. → ปริมาตรที่ได้เป็น ลบ.ซม. หารด้วย 1,000,000 เป็น CBM (ลบ.ม.) */
  const volume = hasSize
    ? (Number(wide) * Number(long) * Number(high)) / 1000000
    : null;

  const [optionUnit, setOptionUnit] = useState([]);
  const [optionPrefix, setOptionPrefix] = useState([]);

  const [formDetail, setFormDetail] = useState([]);

  const [openModalPackingType, setOpenModalPackingType] = useState(false);
  const [openModalSupplier, setOpenModalSupplier] = useState(false);
  const [openModalUnit, setOpenModalUnit] = useState(false);
  // const [packageTypeOption, setPackingTypeOption] = useState([]);
  const [prefixCode, setPrefixCode] = useState(null);
  const [pkCode, setPkCode] = useState("");

  /* โหมดดูอย่างเดียว (กดรหัสจากหน้ารายการ) — แสดงข้อมูลเหมือนหน้าแก้ไข
     แต่กรอกไม่ได้และไม่มีปุ่ม Save */
  const isViewMode = config?.action === "view";

  /// upload image
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("Preview");

  const init = async () => {
    if (config?.action !== "create") {
      pkservice
        .get(config?.code)
        .then(async (res) => {
          const { data: detail, file } = res.data;

          const init = {
            ...detail,
          };

          setFormDetail(init);
          form.setFieldsValue({ ...init });
          form.setFieldValue("packing_code1", detail.packing_code);

          let fileurl = file.map((data) => ({
            ...data,
            file_name:
              `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
              form.getFieldValue("packing_code") +
              "/" +
              data.file_name,
          }));
          // console.log(fileurl) ;
          const formattedFileList = fileurl.map((data) => ({
            img_id: data.img_id,
            uid: data.uid,
            name: data.name,
            status: "done",
            url: data.file_name,
          }));
          setFileList(formattedFileList);
          form.setFieldsValue({ prod_img: formattedFileList });
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    }
  };

  useEffect(() => {
    init();
    GetItemsUnit();
    GetPrefix();
    return () => {};
  }, []);

  useEffect(() => {
    fnsetPKcode(); // อัปเดตค่า pkCode เมื่อฟอร์มเปลี่ยนแปลง
    // alert(pkCode);
  }, [form.getFieldValue("packing_code")]);

  const handlePreview = async (file) => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    // setPreviewTitle(""
    //   // file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    // );
  };

  const handleRemove = (file) => {
    const newFileList = fileList.filter((f) => f.uid !== file.uid);
    setFileList(newFileList);
    //message.success(`File deleted successfully`);
  };

  const onRemove = (file) => {
    // console.log(file);
    //debugger
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const formData_Del = new FormData();
          formData_Del.append("img_id", file.img_id);
          formData_Del.append("file", file);
          formData_Del.append("uid", file.uid);
          formData_Del.append("stcode", form.getFieldValue("packing_code"));
          formData_Del.append("filename", file.name);

          const actions =
            config?.action !== "create"
              ? pkservice.deletePicUpdate(formData_Del)
              : pkservice.deletePic(formData_Del);

          actions.then(async (res) => {
            //debugger
            let { status, data } = res;
            if (status === 200 && data.status === "1") {
              handleRemove(file);
            } else {
              // alert(data.message)
            }
          });
        } catch (error) {
          message.error("Failed to delete file");
        }
      }
    });

    // console.log(fileList);
  };

  const onUploadSuccess = (file) => {
    //debugger
    // alert(`${BACKEND_URL_MAIN}/uploads/` + file.uid + "_" + file.name);
    const newFile = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url:
        `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
        form.getFieldValue("packing_code") +
        "/" +
        "Item_Pic" +
        "_" +
        file.name,
    };
    setFileList((prevFileList) => [...prevFileList, newFile]);
    // console.log(file);
    // console.log('-----');
    // console.log(fileList);
  };

  const fnsetPKcode = () => {
    setPkCode(
      (form.getFieldValue("prefixLabel") !== undefined
        ? form.getFieldValue("prefixLabel")
        : "") +
        (form.getFieldValue("prefixLabel") !== undefined &&
        form.getFieldValue("packing_code") !== undefined
          ? "-"
          : "") +
        (form.getFieldValue("packing_code") !== undefined
          ? form.getFieldValue("packing_code")
          : "")
    ); // อัปเดตค่า pkCode เมื่อฟอร์มเปลี่ยนแปลง
  };

  const GetItemsUnit = () => {
    opService.optionsUnit().then((res) => {
      let { data } = res.data;
      setOptionUnit(data);
    });
  };

  const GetPrefix = () => {
    opService.optionsRuncode({ p: "packing" }).then((res) => {
      let { data } = res.data;
      // let code = data.run_number
      setOptionPrefix(data);
    });
  };

  const handleChoosedPackingType = (v) => {
    // console.log(v)
    const f = form.getFieldsValue();
    const val = {
      ...formDetail,
      ...f,
      packingtype_id: v.packingtype_id,
      packingtype_name: v.packingtype_name,
    };

    setFormDetail(val);

    form.setFieldsValue(val);
  };

  const handleChoosedSupplier = (v) => {
    const f = form.getFieldsValue();
    const val = { ...formDetail, ...f, supcode: v.supcode, supname: v.supname };
    setFormDetail(val);

    form.setFieldsValue(val);
  };

  const handleChoosedUnit = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      unit: value.unitname,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleConfirm = () => {
    form.validateFields().then((v) => {
      const parm = {
        ...formDetail,
        ...form.getFieldsValue(),
        prefixLabel: form.getFieldValue("prefixLabel"),
      };
      const actions =
        config?.action !== "create"
          ? pkservice.update(parm)
          : pkservice.create(parm);
      // console.log(parm)

      actions
        .then(async (r) => {
          message.success("Request success.");

          navigate(from, { replace: true });
          await delay(300);
          console.clear();
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "error request");
        });
    });
  };

  const handleCancel = () => setPreviewOpen(false);

  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };

  const prefixSelector = (
    <Form.Item name="prefixid" noStyle>
      <Select
        style={{
          width: 350,
          textAlign: "left",
          paddingLeft: "10px",
        }}
        onChange={(v, l) => {
          form.setFieldValue("prefixLabel", l.text);
          // หรือเก็บใน state
          setPrefixCode(l.id);
          opService
            .optionsGetLastcode({ p: "packaging", id: v })
            .then((res) => {
              let { data } = res;
              setPrefixCode(data.data);
              const val = {
                ...formDetail,
                prefix: l.text,
              };
              setFormDetail(val);
            });
          fnsetPKcode();
        }}
        options={optionPrefix.map((item) => ({
          value: item.id,
          label: item.value + " - " + item.definition,
          text: item.value,
        }))}
      ></Select>
    </Form.Item>
  );

  let redcode = (
    <>
      {pkCode && pkCode !== "NaN" && (
        <span style={{ paddingLeft: "20px" }}>
          {"ตัวอย่างรหัสใหม่ " + pkCode}
        </span>
      )}
      <span style={{ color: "red", paddingLeft: "10px" }}>
        {prefixCode !== null ? " รหัสล่าสุด " + prefixCode : ""}
      </span>
    </>
  );

  const propsAdd = {
    customRequest: async ({ file, onSuccess, onError }) => {
      if (
        form.getFieldValue("packing_code") !== "" &&
        form.getFieldValue("packing_code") !== undefined
      ) {
        // console.log(fileList);
        const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif"]; // รายการสกุลไฟล์ที่อนุญาต
        const fileExtension = file.name.slice(
          ((file.name.lastIndexOf(".") - 1) >>> 0) + 2
        ); // สกุลไฟล์ของไฟล์ที่อัพโหลด
        if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`)) {
          message.error("สกุลไฟล์ไม่ถูกต้อง");
          onError();
          return false;
        } else {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("uid", file.uid);
          formData.append("stcode", form.getFieldValue("packing_code"));
          formData.append("stcode_type", "PK");
          // console.log(file)
          try {
            pkservice.uploadPic(formData).then(async (res) => {
              //debugger
              let { status, data } = res;
              if (status === 200 && data.status === "1") {
                onUploadSuccess(file);
                onSuccess();
                message.success(`${file.name} file uploaded successfully`);
              } else {
                // alert(data.message)
              }
            });
          } catch (error) {
            onError(error);
            message.error(`${file.name} file upload failed.`);
          }
        }
        // console.log(fileList);
      } else message.error(`กรุณากรอกรหัสสินค้าก่อน.`);
    },
  };

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>ข้อมูลหลัก</Divider>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action === "create"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item
            label={
              <span>
                <span>Packing Code</span>
                {redcode}
              </span>
            }
            name="packing_code"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input
              addonBefore={
                <Text
                  style={{
                    width: 150,
                  }}
                >
                  {prefixSelector}
                </Text>
              }
              onChange={() => fnsetPKcode()}
              placeholder="Enter Packing Code."
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action !== "create"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="Packing Code" name="packing_code1">
            <Input readOnly />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item
            label="Packing Name"
            name="packing_name"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input placeholder="Enter Packing Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="Packing Name (English)" name="packing_nameEN">
            <Input placeholder="Enter Packing Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="Express Name" name="express_name">
            <Input placeholder="Enter Express Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="ชื่อที่ใช้สั่งซื้อ" name="purchase_name">
            <Input placeholder="Enter Purchase Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="Spec Name" name="spec_name">
            <Input placeholder="Enter Spec Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="ประเภท">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="เลือกประเภท"
                value={
                  !!formDetail.packingtype_id ? formDetail.packingtype_name : ""
                }
              />
              <Button
                type="primary"
                className="bn-primary"
                icon={<SearchOutlined />}
                style={{ minWidth: 40 }}
                onClick={() => setOpenModalPackingType(true)}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item label="หน่วยสินค้า :" name="unit">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Unit"
                value={!!formDetail.unit ? `${formDetail.unit} ` : ""}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalUnit(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action !== "create"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานะการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "เปิดการใช้งาน",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "ปิดการใช้งาน",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
          รูปสินค้า
          <Form.Item
            name="prod_img"
            getValueFromEvent={(event) => {
              return event?.fileList;
            }}
            // rules={[
            //   {
            //     required: true,
            //     message: "กรุณาอัพโหลดรูปสินค้า!",
            //   },
            // ]}
          >
            <Upload
              {...propsAdd}
              fileList={fileList}
              listType="picture-card"
              onPreview={handlePreview}
              onRemove={onRemove}
            >
              {fileList.length >= 1 ? null : uploadButton}
            </Upload>
          </Form.Item>
        </Col>
        <Divider {...dividerProp}>สเป็คกล่อง</Divider>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item name="unit_pc" label="Unit/pc">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              // max="10"
              step="0.01"
              placeholder="Enter Unit per PC"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item
            label="CBM"
            tooltip="คำนวณจาก ความกว้าง x ความยาว x ความสูง หารด้วย 1,000,000 (ซม. เป็น ลบ.ม.) — แก้ไขไม่ได้"
            extra={
              hasSize
                ? `${Number(wide).toLocaleString()} x ${Number(long).toLocaleString()} x ${Number(high).toLocaleString()} / 1,000,000`
                : "กรอกความกว้าง ความยาว และความสูงให้ครบ"
            }
          >
            <Input
              size="large"
              readOnly
              className="!bg-zinc-100"
              value={
                volume === null
                  ? ""
                  : volume.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    })
              }
              placeholder="คำนวณอัตโนมัติ"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item name="wide" label="ความกว้าง">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              // max="10"
              step="0.01"
              placeholder="ใส่ความกว้าง"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item name="long" label="ความยาว">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              // max="10"
              step="0.01"
              placeholder="ใส่ความยาว"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item name="high" label="ความสูง">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              // max="10"
              step="0.01"
              placeholder="ความสูง"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item name="min_stock" label="สต๊อกขั้นต่ำ">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              placeholder="ใส่จำนวนสต๊อกขั้นต่ำ"
            />
          </Form.Item>
        </Col>
      </Row>
      {/* <Divider {...dividerProp}>ราคา</Divider>
        <Row gutter={[8,8]} className='px-2 sm:px-4 md:px-4 lg:px-4'>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} >
                <Form.Item label='ราคา' name='price' rules={[ { required: true, message: "Please enter data!", } ]}>
                    <InputNumber min={0} placeholder='Enter Price.' style={{ width: '100%', height: '40px' }} className='input-40' controls={false} />
                </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>          
        </Col>      
        </Row> */}
      <Divider {...dividerProp}>อื่นๆ</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <Form.Item label="Remark" name="remark">
            <Input.TextArea placeholder="Enter Remark." rows={5} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionTop = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!isViewMode && (
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              Save
            </Button>
          )}
        </Flex>
      </Col>
      {/* <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!!code && (
            <ButtonUpload code={code} refer="Packing" showExpire={true} />
          )}
        </Flex>
      </Col> */}
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!isViewMode && (
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              Save
            </Button>
          )}
        </Flex>
      </Col>
    </Row>
  );

  return (
    <div className="packing-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space direction="vertical" className="flex gap-2">
        {SectionTop}
        <Form form={form} layout="vertical" autoComplete="off" disabled={isViewMode}>
          <Card title={config?.title}>{Detail}</Card>
        </Form>
        {SectionBottom}
      </Space>

      {openModalPackingType && (
        <ModalPackingType
          show={openModalPackingType}
          close={() => {
            setOpenModalPackingType(false);
          }}
          values={(v) => {
            handleChoosedPackingType(v);
          }}
        />
      )}

      {openModalSupplier && (
        <ModalSupplier
          show={openModalSupplier}
          close={() => {
            setOpenModalSupplier(false);
          }}
          values={(v) => {
            handleChoosedSupplier(v);
          }}
        />
      )}

      {openModalUnit && (
        <ModalUnit
          show={openModalUnit}
          close={() => {
            setOpenModalUnit(false);
          }}
          values={(v) => {
            handleChoosedUnit(v);
          }}
        />
      )}

      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={1200}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </div>
  );
};

export default PackingManage;
